<template>
  <div
    class="card"
    :class="{'flipped' : active}"
    @click="clickHandler"
  >
  <div class="imgcon h-full w-full custom-green front flex items-center justify-center rounded-md">
    <img
      :src="`${baseUrl}images/memo/${set}/${card.img}`"
      alt="ac"
      class="h-full w-full object-full xs:h-4/5 xs:w-4/5 rounded-md"
    />
  </div>
    <img
      src="../assets/back.jpg"
      alt="back"
      class="h-full w-full back rounded-md"
    />
  </div>
</template>

<script>
export default {
  name: 'card-component',
  props: ['card','active','set'],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  methods : {
    clickHandler(){
      if(!this.active){
        this.$emit('card-clicked', this.card);
      }
    }
  }
};
</script>

<style scoped>
.front {
  transform: rotateY(90deg);
  transition: all ease-in 0.2s;
  position: absolute;
}
.flipped .front {
  transform: rotateY(0deg);
  transition-delay: 0.2s;
}
.back {
  transition: all ease-in 0.2s;
  transition-delay: 0.2s;
}
.flipped .back {
  transform: rotateY(90deg);
  transition-delay: 0s;
}
</style>